/**
 * Filter to format a number according to the settings
 */
/** @ngInject */
export const NUMBERFORMAT_KEY = 'numberFormat';

export function fsNumberFilter($cookies, userService) {

    return function(number, fractionSize) {
        const format = userService.fsMainDependencies.settings ?
            userService.fsMainDependencies.settings.numberFormatConverted :
            JSON.parse(JSON.stringify($cookies.get(NUMBERFORMAT_KEY)));

        if(format) { // new deep clone copy
            $cookies.put(NUMBERFORMAT_KEY, format);
        }

        return number == null ? null : number.toLocaleString(format, { minimumFractionDigits: fractionSize });
    };
}
